// extracted by mini-css-extract-plugin
export default {"reaction":"Reactions_reaction__fm5uQ"};